import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { NgxSpinnerService } from 'ngx-spinner';
import { AdvancedDataSource } from 'src/app/controls/advanced-gridview/datasources/advanced-datasource';
import { AdvancedGridviewModel } from 'src/app/controls/advanced-gridview/models/advanced-gridview-model';
import { ColumnDefinition } from 'src/app/controls/advanced-gridview/models/column-definition';
import { ColumnListDefinition } from 'src/app/controls/advanced-gridview/models/column-list-definition';
import { ColumnType } from 'src/app/controls/advanced-gridview/models/column-type';
import { MenuITemAction } from 'src/app/controls/advanced-gridview/models/menu-item-action';
import { MenuItemEvent } from 'src/app/controls/advanced-gridview/models/menu-item-event';
import { SortInfos } from 'src/app/controls/advanced-gridview/models/sort-infos';
import { FilterType } from 'src/app/controls/filters/models/filter-type';
import { ListItem } from 'src/app/controls/filters/models/list-item';
import { DefaultListComponent } from 'src/app/controls/list/default-list/default-list.component';
import { EnumHelper } from 'src/app/helpers/enum-helper';
import { Channel } from 'src/app/models/channel';
import { ChannelType } from 'src/app/models/enums/channel-type';
import { Rights } from 'src/app/models/enums/rights';
import { ViewType } from 'src/app/models/enums/view-type';
import { BoxesService } from 'src/app/services/boxes.service';
import { ChannelService } from 'src/app/services/channel.service';
import { EmailAddressesService } from 'src/app/services/emailAddress.service';
import { FoldersStatesService } from 'src/app/services/folders-states.service';
import { MemoryService } from 'src/app/services/memory.service';
import { NotificationService } from 'src/app/services/notification-service';
import { AdvancedGridviewComponent } from '../../../controls/advanced-gridview/advanced-gridview.component';

@Component({
    selector: 'app-channel-list',
    templateUrl: './channel-list.component.html',
    styleUrls: ['./channel-list.component.scss'],
    imports: [AdvancedGridviewComponent]
})
export class ChannelListComponent extends DefaultListComponent<Channel> implements OnInit {
    typeColumnValues: ListItem<string>[] = [
        new ListItem(ChannelType.Fax.toString(), 'Fax'),
        new ListItem(ChannelType.Email.toString(), 'Email'),
        new ListItem(ChannelType.Sms.toString(), 'Sms'),
        new ListItem(ChannelType.Vocal.toString(), 'Vocal'),
        new ListItem(ChannelType.Chat.toString(), 'Chat'),
    ];

    /**
     * Configuration des colonnes de la liste.
     */
    tableConfig: ColumnDefinition[] = null;

    /**
     * Constructeur
     * @param dialog : Service pour ouvrir des boites de dialogue.
     * @param memoryService : Service pour récupérer les informations en mémoire.
     * @param enumHelper : Classe utilitaire pour les énumérations.
     * @param channelService : Service de gestion des canaux de réception.
     * @param boxeservice : Service de gestion des bannettes.
     */
    constructor(
        public override dialog: MatDialog,
        protected override memoryService: MemoryService,
        public enumHelper: EnumHelper,
        private channelService: ChannelService,
        private boxeservice: BoxesService,
        private emailAddressesService: EmailAddressesService,
        private folderStateService: FoldersStatesService,
        private spinner: NgxSpinnerService,
        private notificationService: NotificationService
    ) {
        super(dialog, memoryService);

        // Specifie des colonnes en fonction des droits utilisateurs
        if (this.memoryService.getConnectedUser().params.idVisible === true) {
            this.tableConfig = [
                new ColumnDefinition('id', 'Id', ColumnType.Numeric, FilterType.Text, 1, 5, true),
                new ColumnListDefinition('channelType', 'Canal', FilterType.List, 2, 10, true, false, this.typeColumnValues),
                new ColumnListDefinition('addressId', 'Adresse', FilterType.List, 3, 22, true, false),
                new ColumnDefinition('ocrEnabled', 'Ocr', ColumnType.Boolean, FilterType.Boolean, 4, 8, true),
                new ColumnDefinition('customerIdentificationEnabled', 'Identification client', ColumnType.Boolean, FilterType.Boolean, 5, 8, true),
                new ColumnDefinition('documentIdentificationEnabled', 'Ientification document', ColumnType.Boolean, FilterType.Boolean, 6, 8, true),
                new ColumnDefinition('attributesAssignmentEnabled', 'Assignation attributs', ColumnType.Boolean, FilterType.Boolean, 7, 8, true),
                new ColumnDefinition('ladEnabled', 'Lad', ColumnType.Boolean, FilterType.Boolean, 8, 8, true),
                new ColumnDefinition('autoLinkEnabled', 'Rattachement automatique', ColumnType.Boolean, FilterType.Boolean, 9, 8, true),
                new ColumnListDefinition('defaultStateId', 'État par défaut', FilterType.List, 11, 10, true, false),
            ];
        } else {
            this.tableConfig = [
                new ColumnListDefinition('channelType', 'Canal', FilterType.List, 2, 10, true, false, this.typeColumnValues),
                new ColumnListDefinition('addressId', 'Adresse', FilterType.List, 3, 27, true, false),
                new ColumnDefinition('ocrEnabled', 'Ocr', ColumnType.Boolean, FilterType.Boolean, 4, 8, true),
                new ColumnDefinition('customerIdentificationEnabled', 'Identification client', ColumnType.Boolean, FilterType.Boolean, 5, 8, true),
                new ColumnDefinition('documentIdentificationEnabled', 'Ientification document', ColumnType.Boolean, FilterType.Boolean, 6, 8, true),
                new ColumnDefinition('attributesAssignmentEnabled', 'Assignation attributs', ColumnType.Boolean, FilterType.Boolean, 7, 8, true),
                new ColumnDefinition('ladEnabled', 'Lad', ColumnType.Boolean, FilterType.Boolean, 8, 8, true),
                new ColumnDefinition('autoLinkEnabled', 'Rattachement automatique', ColumnType.Boolean, FilterType.Boolean, 9, 8, true),
                new ColumnListDefinition('defaultStateId', 'État par défaut', FilterType.List, 11, 10, true, false),
            ];
        }

        if (this.memoryService.getSelectedView().viewType === ViewType.Box) {
            this.tableConfig.splice(8, 0, new ColumnListDefinition('defaultBoxId', 'bannette par défaut', FilterType.List, 10, 10, true, false));
        }

        this.AddMenuItem('Dupliquer', MenuITemAction.Duplicate, Rights.ProcessCreate);
        this.AddMenuItem('Éditer', MenuITemAction.Update, Rights.ProcessEdit);
        this.AddMenuItem('Supprimer', MenuITemAction.Delete, Rights.ProcessDelete);
    }

    /**
     * Initialise le composant.
     */
    ngOnInit(): void {
        this.dataSource = new AdvancedDataSource(null, this.channelService, this.spinner, this.notificationService);
        this.filteredTableModel = new AdvancedGridviewModel(this.tableConfig, new SortInfos('addressId', 'asc'));

        // Ajout des listes déroulantes
        // attente de 500ms pour que la gridView ait le temps de se remplir.
        setTimeout(() => {
            this.loadListColumnFilterDatas();
        }, 500);
    }

    /**
     * Appellé lorsque l'utilisateur clique sur un élément du menu contextuel.
     * @param event : Événement retourné par le menu contextuel.
     */
    public onAction(event: MenuItemEvent<Channel>): void {
        if (event.action == MenuITemAction.Read) {
            // Cas de la consultation.
            this.itemDisplayed.emit(event.context);
        } else if (event.action == MenuITemAction.Update) {
            // Cas de la mise à jour.
            this.itemEdited.emit(event.context);
        } else if (event.action == MenuITemAction.Duplicate) {
            // Cas de duplication.
            this.itemDuplicated.emit(event.context);
        } else if (event.action == MenuITemAction.Delete) {
            // Cas de la suppression --> affichage de la boite de dialogue de confirmation.
            this.displayDeleteConfirmationDialog(`Vous êtes sur le point de supprimer le canal de réception '${event.context.id}'.`, event.context);
        }
    }

    /**
     * Charge les éléments des filtres des colonnes de type liste.
     */
    private loadListColumnFilterDatas(): void {
        if (this.memoryService.getSelectedView().viewType === ViewType.Box) {
            this.boxeservice.List(null, null, null, null).subscribe((x) => {
                var listItem = x.value.map<ListItem<string>>((v) => <ListItem<string>>{ value: v.id.toString(), text: v.name });
                this.loadColumn(
                    this.filteredTableModel.displayedColumnsDefinitions.find(
                        (x) => this.enumHelper.areEquals(ColumnType, x.type, ColumnType.List) && x.columnName === 'defaultBoxId'
                    ) as ColumnListDefinition<string>,
                    listItem
                );
            });
        }

        this.emailAddressesService.List(null, null, null, null).subscribe((x) => {
            var listItem = x.value.map<ListItem<string>>((v) => <ListItem<string>>{ value: v.id.toString(), text: v.address });
            this.loadColumn(
                this.filteredTableModel.displayedColumnsDefinitions.find(
                    (x) => this.enumHelper.areEquals(ColumnType, x.type, ColumnType.List) && x.columnName === 'addressId'
                ) as ColumnListDefinition<string>,
                listItem
            );
        });

        this.folderStateService.List(null, null, null, null).subscribe((x) => {
            var listItem = x.value.map<ListItem<string>>((v) => <ListItem<string>>{ value: v.id.toString(), text: v.name });
            this.loadColumn(
                this.filteredTableModel.displayedColumnsDefinitions.find(
                    (x) => this.enumHelper.areEquals(ColumnType, x.type, ColumnType.List) && x.columnName === 'defaultStateId'
                ) as ColumnListDefinition<string>,
                listItem
            );
        });
    }
}
